import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useStyles } from './styles'

const FormSectionContainer = ({ id, title, children }) => {
  const classes = useStyles()

  return (
    <Box id={id} className={classes.fieldGroup}>
      <Typography className={classes.pageTitle}>{title}</Typography>
      {children}
    </Box>
  )
}

export default FormSectionContainer
